import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { PrivateRoute } from '../components';
import Links from './Links/Links';
import LinkCreate from './LinkCreate/LinkCreate';
import LinkCreateBulkStart from './LinkCreateBulkStart/LinkCreateBulkStart';
import LinkCreateBulkExcel from './LinkCreateBulkExcel/LinkCreateBulkExcel';
import LinkCreateBulk from './LinkCreateBulk/LinkCreateBulk';
import TargetCheck from './TargetCheck/TargetCheck';
import Tutorial from './Tutorial/Tutorial';
import Imprint from './Imprint';
import DataProtection from './DataProtection';
import Login from './Login/Login';
import Logout from './Logout';
import PasswordReset from './PasswordReset/PasswordReset';
import PasswordChange from './PasswordChange/PasswordChange';
import { subPages as adminPages } from './Admin';
import Page404 from './404';

export default () => (
  <Switch>
    <PrivateRoute exact={true} path="/" component={Links} />
    <PrivateRoute path="/link-create" component={LinkCreate} />
    <PrivateRoute
      exact={true}
      path="/link-bulk-upload"
      component={LinkCreateBulkStart}
    />
    <PrivateRoute
      path="/link-bulk-upload/with-excel"
      component={LinkCreateBulkExcel}
    />
    <PrivateRoute
      path="/link-bulk-upload/create/:marketId?/:templateId?"
      component={LinkCreateBulk}
    />
    <PrivateRoute path="/target-check" component={TargetCheck} />
    {adminPages.map((page) => (
      <PrivateRoute key={page.path} {...page} />
    ))}
    <PrivateRoute path="/tutorial" component={Tutorial} />
    <Route path="/imprint" component={Imprint} />
    <Route path="/data-protection" component={DataProtection} />
    <PrivateRoute path="/logout" component={Logout} />
    <Route path="/login/:user?/:pass?" component={Login} />
    <Route path="/password-reset" component={PasswordReset} />
    <Route path="/password-change/:email/:code*" component={PasswordChange} />
    <Route path="/password-change/:email" component={PasswordChange} />
    <Route component={Page404} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/views/index.tsx